const oYeetCustom = {
  padLeftZero(str) { return ('00' + str).substr(str.length) },
  
  isMobile() {
    return navigator.userAgent.match(/(iPhone|iPod|Android|ios|SymbianOS|BlackBerry|webOS)/i)
  },
  
  // html/js/css filter
  specialFilter(s) {
    s = s.replace(/<\s*script[^>]*>(.|[\r\n])*?<\s*\/script[^>]*>/gi, '');
    s = s.replace(/<\s*style[^>]*>(.|[\r\n])*?<\s*\/style[^>]*>/gi, '');
    s = s.replace(/<\/?[^>]+>/g, '');
    s = s.replace(/\&[a-z]+;/gi, '');
    return s
  },
  
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
      }
    }
    return fmt;
  },
  
  getUrlParam(variable) {
    let reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    let context = "";
    if (r != null) { context = r[2]; }
    reg = null;
    r = null;
    return context == null || context === "" || context === "undefined" ? "" : context;
  },

  encrypt(str) {
    const KEY = '1274567898882222';
    const IV = '8NONwyJtHesysWpM'

    var key = CryptoJS.enc.Utf8.parse(KEY);
    var iv = CryptoJS.enc.Utf8.parse(IV);

    var encrypted = CryptoJS.AES.encrypt(str, key, {
      iv: iv,

      mode: CryptoJS.mode.CBC,

      padding: CryptoJS.pad.Pkcs7

    });

    return encrypted.toString();
  },

  decrypt(str) {
    const KEY = '1274567898882222';
    const IV = '8NONwyJtHesysWpM'

    var key = CryptoJS.enc.Utf8.parse(KEY);

    var iv = CryptoJS.enc.Utf8.parse(IV);

    var decrypted = CryptoJS.AES.decrypt(str, key, {
      iv: iv,

      padding: CryptoJS.pad.Pkcs7

    });

    return decrypted.toString(CryptoJS.enc.Utf8);

  }
}